import React, { useEffect, useRef } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Grid, Input, Line } from 'components'
import { DraggableDialog } from 'components/DraggableDialog/DraggableDialog'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import useLoading from 'hooks/useLoading'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { ISectorParams } from 'services/NGT/ContractsParams'
import { COLORS, SPACING } from 'utils'
import * as Yup from 'yup'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './EditSectorModal.style'

interface IEditSectorModal {
  showModal: boolean
  toggleModal: () => void
  handleSubmitUpdate: any
  sectorData: ISectorParams
}

const schema = Yup.object({
  dsSetorContrato: Yup.string().required('O campo negócio é obrigatório')
})

const EditSectorModal: React.FC<IEditSectorModal> = ({
  showModal,
  toggleModal,
  handleSubmitUpdate,
  sectorData
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm<ISectorParams>({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    setValue('dsSetorContrato', sectorData?.dsSetorContrato)
  }, [sectorData])

  const { loading, msgErro, setLoading } = useLoading()

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      onClose={toggleModal}
      width={'md'}
    >
      <FormDialog
        onSubmit={handleSubmit((data) => {
          handleSubmitUpdate({
            ...data,
            idSetorContrato: sectorData?.idSetorContrato
          })
          reset()
        })}
      >
        <Line />
        <DialogTitleStyled>Editar Negócio</DialogTitleStyled>
        <DialogContentStyled>
          <Grid
            gridCols="1fr 3fr 1fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
          >
            <Input
              label="Código"
              formValue="idSetor"
              required
              value={sectorData?.idSetorContrato}
              disabled
            />
            <Input
              control={control}
              errors={errors}
              label="Negócio"
              placeholder="negócio"
              formValue="dsSetorContrato"
              defaultValue={sectorData?.dsSetorContrato}
              maxLength={20}
              required
            />
          </Grid>
          <SuccessModal
            open={loading === 'error'}
            message={msgErro}
            type="error"
            hideButtonCancel
            handleConfirm={() => setLoading('idle')}
            txtButtonConfirm="Voltar"
          />
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            backgroundColor={COLORS.white}
            textColor={COLORS.black}
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing15}
            borderColor={COLORS.black}
            onClick={() => {
              toggleModal()
              reset()
            }}
          />
          <Button
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing15}
            text="Salvar"
            type="submit"
          />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default EditSectorModal
